import arrays from './arrays';
import build from './build';
import colors from './colors';
import errors from './errors';
import helpers from './helpers';
import images from './images';
import request from './request';
import redux from './redux';
import typo from './typo';
import math from './math';
import app from './app';
import dates from './dates';
import numbers from './numbers';
import comparisons from './comparisons';
import ativosSortOptions from './ativosSortOptions';
import ativosFilterRegistry from './ativosFilterRegistry';
import sliderScales from './sliderScales';

const utils = {
  arrays,
  helpers,
  build,
  colors,
  errors,
  images,
  request,
  redux,
  typo,
  math,
  app,
  dates,
  numbers,
  comparisons,
  ativosSortOptions,
  ativosFilterRegistry,
  sliderScales
};

export default utils;
